import axios from "@lib/axios";

export async function getFeaturedPlan(locale) {
  const res = await axios.get('plan', {
    headers: { Language: locale },
  });

  return res.data.data;
}
